import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { SmTermsAndConditionsAccordionComponent } from "./sm-terms-and-conditions-accordion.component";

const DIRECTIVES: any[] = [SmTermsAndConditionsAccordionComponent];

@NgModule({
	imports: [CommonModule, GlobalUiModule, TranslateModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class SmTermsAndConditionsAccordionModule {}
